<template>
  <v-app-bar id="app-bar"
    fixed
    app
    elevation="2"
    height="75"
   >
    <v-btn class="mr-3" elevation="1" color="accent"  text fab small @click="setDrawer(!drawer)">
      <v-icon v-if="value">mdi-view-quilt</v-icon>
      <v-icon v-else>mdi-dots-vertical</v-icon>
    </v-btn>

    <v-toolbar-title class="hidden-sm-and-down font-light" v-text="$route.name" color="accent"  />

    <v-spacer />

    <div class="mx-3" />

   
     <v-btn color="accent"  class="ml-4" min-width="0" text to="/college/Dashboard">
      <v-icon>mdi-chart-multiple</v-icon>Dashboard
    </v-btn>
 <v-btn color="accent"  class="ml-4" min-width="0" text to="/college/home_menu">
      <v-icon>mdi-home</v-icon>เมนูระบบ
    </v-btn>

    <v-btn color="warning"  class="ml-4" min-width="0" text @click="confirmLogout()">
      <v-icon>mdi-exit-to-app</v-icon>ออกจากระบบ
    </v-btn>
  </v-app-bar>
</template>

<script>
// Utilities
import { mapState, mapMutations } from "vuex";

export default {
  name: "DashboarduserAppBar",

  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(["drawer"]),
  },

  methods: {
    ...mapMutations({
      setDrawer: "SET_DRAWER",
    }),
    confirmLogout() {
      Swal.fire({
        title: "ออกจากระบบ",
        text: "คุณต้องการออกจากระบบหรือไม่?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#e74c3c",
        cancelButtonColor: "#95a5a6",
        confirmButtonText: "ออกจากระบบ",
        cancelButtonText: "ยกเลิก"
      }).then(result => {
        if (result.isConfirmed) {
          this.logout();
        }
      });
    },
    logout() {
      sessionStorage.clear();
      this.$router.push("/");
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css?family=Prompt');

#app-bar {
  background-color: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  color: #1e293b;
}
</style>
